<template>
  <div
    class="py-2"
  >
    <v-row class="pl-5 mt-n3 font-calibri font-16 font-weight-bold border-bottom-light-grey accordion-max-height">
      <v-col>
        Banks
        <span v-if="statusFilter">
          <setup-companies-banks-dialog-create
            v-if="$hasPermissionTo(['create company banks'])"
            :company-id="company.id"
            @created="loadCompanyBanks(company.id)"
          />
        </span>
      </v-col>
    </v-row>
    <v-row class="mb-n10 font-calibri">
      <v-col>
        <v-data-table
          :items="companyBanks"
          :headers="companyBankHeaders"
          hide-default-footer
          dense
          class="mt-2"
          :loading="companyBankLoading"
        >
          <template v-slot:item.is_default="{ item }">
            <v-icon medium>
              {{ item.is_default ? 'mdi mdi-check-outline text-success' : 'mdi mdi-close-outline text-danger' }}
            </v-icon>
          </template>

          <template v-slot:item.action="{ item }">
            <setup-companies-banks-dialog-edit
              v-if="$hasPermissionTo(['update company banks']) && !company.deleted_at"
              :company-bank="item"
              @updated="loadCompanyBanks(item.company_id)"
            />
            <setup-companies-banks-dialog-delete
              v-if="$hasPermissionTo(['delete company banks']) && !company.deleted_at"
              :company-bank="item"
              @deleted="loadCompanyBanks(item.company_id)"
            />
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {  
    components: {
      SetupCompaniesBanksDialogCreate: () => import('@/components/hris/setup/companies/banks/DialogCreate'),
      SetupCompaniesBanksDialogEdit: () => import('@/components/hris/setup/companies/banks/DialogEdit'),
      SetupCompaniesBanksDialogDelete: () => import('@/components/hris/setup/companies/banks/DialogDelete'),
    },
    props: {
      company: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        companyBankHeaders: [
          {
            text: 'Bank',
            align: 'left',
            value: 'payroll_bank.name',
          },
          {
            text: 'Account No.',
            align: 'left',
            value: 'bank_account_no',
          },
          {
            text: 'Is Default?',
            align: 'center',
            value: 'is_default',
          },
          {
            sortable: false,
            text: '',
            align: 'center',
            value: 'action',
          },
        ],
        companyBankLoading: false,
        companyBanks: [],
        panel: [0],
      }
    },

    watch: {
      company: function (value) {
        if (!value) return
        this.refreshData()
      },
    },

    created () {
      this.refreshData()
    },
    methods: {
      refreshData () {
        this.loadCompanyBanks(this.company.id)
      },

      loadCompanyBanks (companyId) {
        this.companyBankLoading = true

        this.$api.companyBanks().show(companyId)
          .then(res => {
            this.companyBanks = _.orderBy(res.data, ['payroll_bank.name'], ['asc'])

            this.companyBankLoading = false
          })
      },
    },
  }
</script>

<style scoped>
.selected{
  background-color: rgba(0, 0, 0, .05);
}

.remove-bottom-border {
    border-bottom: 0px !important
}

.border-bottom {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important
}

.font-calibri{
    font-family: Calibri !important;
}

.font-16{
    font-size:16px;
}

.accordion-max-height{
  max-height: 36px !important;
}
</style>
